import { createContext, useContext, FC } from 'react';
import { DragDropContextProps, DraggableProps, DroppableProps } from '.';

export type DndModules = {
  Draggable: FC<DraggableProps>;
  Droppable: FC<DroppableProps>;
  DragDropContext: FC<DragDropContextProps>;
};

export const DndComponentsCtxt = createContext<DndModules | null>(null);

export function useDragAndDropComponents() {
  return useContext(DndComponentsCtxt);
}
